import React from "react";
import { useSelector } from "react-redux";
import MovieCard from "./MovieCard";

function ListaFavoritos() {
  const favoritos = useSelector((state) => state.favoritos.peliculas);

  if (!favoritos || favoritos.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white p-4">
        <h2 className="text-4xl font-bold text-center text-gray-400 mb-4 drop-shadow-md">
          ¡No tienes favoritos todavía!
        </h2>
        <p className="text-lg text-center text-gray-300 mb-6">
          Agrega películas a tus favoritos y aparecerán aquí.
        </p>
       
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {favoritos.map((movie) => (
          <MovieCard key={movie.id} movie={movie} isFavorite={true} />
        ))}
      </div>
    </div>
  );
}

export default ListaFavoritos;
